/// <reference path="koyori.ts" />

/**
 * 特定のクラスが付与されている場合に動作します。
 */
window.addEventListener('WebComponentsReady', () => {
	// koy-fit-heightクラスは兄弟クラスを除いて親エレメントにフィットします
	let fitHeight = () => {
		KoyoriElement.querySelectorAll(document.body, '.koy-fit-height').forEach(element => {
			let height = KoyoriElement.getFitHeight(element);
			element.style.height = height + 'px';
		});
	}
	window.addEventListener('resize', () => {
		fitHeight();
	});
	fitHeight();
});